import { PropsWithChildren } from 'react'
import { useMenuLayout } from '../../app/layouts/main-layout/hooks/UseMenuLayout'
import { BpTooltip } from '../../shared/components/cards/tooltip/BpTooltip'

interface CommonMainPageProps extends PropsWithChildren {
  title?: string
  hint?: string
}

export const CommonMainPage = ({ title, hint, children }: CommonMainPageProps) => {
  const { menuLayout } = useMenuLayout()

  return (
    <div className={'flex flex-1 flex-col'}>
      {menuLayout === 'sidebar' && title && (
        <div className={'flex items-center gap-[12px] pb-[12px] leading-[24px]'}>
          <h3 className={'text-[20px] font-semibold text-focus-500'}>{title}</h3>
          {hint && <BpTooltip title={hint} />}
        </div>
      )}
      <div className={'flex flex-1 flex-col'}>{children}</div>
    </div>
  )
}
